// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC<{ width?: number; height?: number }> = ({ width = 28, height = 28 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
            <path
                fill="currentColor"
                d="M28,14.054902 C28,6.31372549 21.7109375,0 14,0 C6.2890625,0 0,6.31372549 0,14.054902 C0,20.6431373 4.5390625,26.1882353 10.609375,27.7254902 L10.609375,18.3372549 L7.7109375,18.3372549 L7.7109375,14.054902 L10.609375,14.054902 L10.609375,12.1882353 C10.609375,7.41176471 12.796875,5.21568627 17.4453125,5.21568627 C18.3203125,5.21568627 19.8515625,5.38039216 20.5078125,5.54509804 L20.5078125,9.44313725 C20.1796875,9.38823529 19.578125,9.38823529 18.8671875,9.38823529 C16.5703125,9.38823529 15.6953125,10.2666667 15.6953125,12.5176471 L15.6953125,14.054902 L20.2890625,14.054902 L19.46875,18.3372549 L15.6953125,18.3372549 L15.6953125,28 C22.640625,27.1764706 28,21.2470588 28,14.054902 Z"
            />
        </svg>
    );
};

export default React.memo(Facebook);
